module.exports = __webpack_public_path__ + "static/media/71fis7dVn8L._AC_SL1500_.f9dc4c20.jpg";